<!-- Inicio Tabla -->

<div class="row">
    <ng-container *ngIf="key1>1">
        <div class="col-md-2">
            <a (click)="changeModel(0)" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar
            </a>
        </div>

        <div class="col-md-6">
            <div class="form-group">
                <input class="form-control" type="file" (change)="onFileSelect($event.target)">
            </div>

        </div>
        <div class="col-md-2">
            <button class="btn-add" (click)="createByCSV()"><i class="fa fa-check-circle"
                    aria-hidden="true"></i></button>
        </div>
    </ng-container>
</div>

<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail">
                <tr class="table-success">
                    <th scope="col">N°</th>
                    <th scope="col">Nombre y apellido</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">Activo</th>
                    <ng-container *ngIf="key==true && key1==1">
                        <th scope="col">Administrador</th>
                    </ng-container>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>

                <tr class="tbody-detail" *ngFor="let user of users; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{user.person.name +' '+ user.person.lastname }}</td>
                    <td><a class="link-detail" routerLink="usuarios">{{ user.email }}</a></td>
                    <td>
                        <div class="label-active text-center" *ngIf="user.isActive">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!user.isActive">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="key1>1">
                        <td><a class="a-icon text-center" title="Editar información usuario"
                                (click)="changeModel(user.id)"><i class="fa fa-pencil i-icon"></i></a></td>
                        <td>
                            <a *ngIf="user.isActive" class="a-icon text-center" title="Quitar acceso"
                                (click)="removeRespondent(user.id,user.person.lastname)"><i
                                    class="fa fa-trash i-icon"></i></a>
                            <a *ngIf="!user.isActive" class="a-icon text-center" title="Activar acceso"
                                (click)="grantRespondent(user.id,user.person.lastname)"><i
                                    class="fa fa-retweet i-icon"></i></a>
                        </td>
                    </ng-container>

                    <ng-container *ngIf="key==true && key1==1">
                        <td>
                            <div class="label-active text-center" *ngIf="user.isAllowed">SI</div>
                            <div class="label-inactive text-center" *ngIf="!user.isAllowed">NO</div>
                        </td>
                        <td>
                            <a *ngIf="user.isAllowed" class="a-icon text-center" title="Quitar privilegio"
                                (click)="removeAdmin(user.id,user.person.lastname)"><i class="fa fa-times-circle-o"
                                    aria-hidden="true"></i></a>
                            <a *ngIf="!user.isAllowed" class="a-icon text-center" title="Otorgar privilegio"
                                (click)="grantAdmin(user.id,user.person.lastname)"><i class="fa fa-check-circle-o"
                                    aria-hidden="true"></i></a>
                        </td>
                    </ng-container>
                </tr>

            </tbody>
        </table>
    </div>
</div>
<!-- Fin Tabla -->


<!-- Inicio Modal -->
<div class="modal fade" id="testModal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Agregar usuario</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
            </div>

            <div class="modal-body">

                <!-- Empieza cuerpo -->
                <form autocomplete="off" [formGroup]="formUsr" (ngSubmit)="save()">

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="name">Nombre</label>
                            <input formControlName="name" type="text" class="form-control"
                                placeholder="Ingrese nombre(s)" id="name">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="lastname">Apellidos</label>
                            <input formControlName="lastname" type="text" class="form-control" id="inputPassword4"
                                placeholder="ingrese sus apellidos" id="lastname">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputEmail4">Email</label>
                            <input formControlName="email" type="email" class="form-control" placeholder="Email"
                                [class.is-invalid]="campoNoValido('email')" id="email">
                            <small class="text-danger" *ngIf="campoNoValido('email')">Ingrese un correo válido</small>
                        </div>

                        <div class="form-group col-md-6">
                            <label for="inputPassword4">Password</label>
                            <input formControlName="pass" type="password" class="form-control" id="inputPassword4"
                                placeholder="Password" autocomplete="off" id="password">
                        </div>

                    </div>

                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" formControlName="isActive">
                            <label class="form-check-label" for="gridCheck">Activo</label>
                        </div>
                    </div>

                    <div class="form-row text-right">
                        <div class="form-group px-2">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        </div>
                        <div class="form-group">
                            <button type=" submit " class="btn btn-outline-primary ">Guardar</button>
                        </div>
                    </div>

                </form>
                <!-- Termina cuerpo -->

            </div>

        </div>
    </div>
</div>
<!-- Fin Modal -->